<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h2 class="text-h5 font-weight-bold">Reportes - Inventario</h2>
        <div class="subtitle-2 grey--text">Selecciona un reporte para ejecutarlo y descargarlo.</div>
      </v-col>
    </v-row>

    <v-row class="mt-2">
      <v-col cols="12" md="6" lg="4">
        <v-card class="report-card" outlined @click="goToProductsSalesReport">
          <v-card-title class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-package-variant-closed</v-icon>
            Productos de venta
          </v-card-title>
          <v-card-text>
            Lista de productos con precio, impuesto, precio publico, categoria, linea y marca.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary">Abrir reporte</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <v-card class="report-card" outlined @click="goToExistenceReport">
          <v-card-title class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-warehouse</v-icon>
            Existencias
          </v-card-title>
          <v-card-text>
            Existencias por almacen con stock minimo, maximo y estado de inventario.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary">Abrir reporte</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ReportsInventorySectionView',
  methods: {
    goToProductsSalesReport() {
      this.$router.push({ name: 'AdminReportInventorySalesProducts' });
    },
    goToExistenceReport() {
      this.$router.push({ name: 'AdminReportInventoryExistence' });
    },
  },
};
</script>

<style scoped>
.report-card {
  cursor: pointer;
  min-height: 190px;
}
</style>
